import React, { useState, useEffect } from 'react';
import Grid from '@mui/material/Grid';
import tick from '../../assets/tick.svg';
import NoEntry from '../../assets/No Entry.svg';
import LockTabButton from '../../assets/Lock Tab Button.svg';
import './BatchWorkflow.css';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { useNavigate, useLocation } from 'react-router-dom';
import httpClient from '../../httpClient';
import ChatTemplate from '../dashboard/OpenDashboard/chatTemplate/chatTemplate';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import { Skeleton } from '@mui/material';
import {Stack} from '@mui/material';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

const BatchWorkflow = ({ props }) => {
  const [isSubmitEnabled, setIsSubmitEnabled] = useState(false);
  const [searchKey, setSearchKey] = useState('');
  const [loading, setLoading] = useState(false);
  const [activestage, setActivestage] = useState(null);
  let [page_data, setPageData] = useState({});
  const navigate = useNavigate();
  
  const location = useLocation();
  const [imageSrc, setImageSrc] = useState(LockTabButton); // Initial image source
  const [jsonData, setJsonData] = useState(null);
  const [stage, setstage] = useState([]);
   const [buttonClicked, setButtonClicked] = useState(false);
  const [showDropdown, setShowDropdown] = useState(false);
  const [batch_task_name, setbatch_task_name] = useState(null);
  const [batch_task_id, setbatch_task_id] = useState(null);
  const [batch_id, setbatch_id] = useState(null);
  const [stage_id, setstage_id] = useState(null);
  const [stage_name, setstage_name] = useState(null);
  const [clicked_stage_form_id, setclicked_stage_form_id] = useState(null);
  const [clicked_stage_text, setclicked_stage_text] = useState(null);
  const [triggerCloseForms, setTriggerCloseForms] = useState(false);
  const [sectionIndex, setSectionIndex] = useState(null);
  const [compType, setCompType] = useState(null);
  const [compIndex, setcompIndex] = useState(null); 
  let [fullScreenMode,setFullScreenMode] = useState(false);
  const [CurrentStage, setCurrentStage] = useState(null);
  const [openMoveStage, setOpenMoveStage] = useState(false);
  const [keyUnmount,setkeyUnmount] = useState('');
  const [refreshCnt, setRefreshCnt] = useState(0);
  const [tempStageCloseOnTry, setTempStageCloseOnTry] = useState(null);
  const [openCloseBatch, setopenCloseBatch] = useState(false);
  
  const [each_view, setEachView] = useState({
    active: true,
    type: "form",
    type_id: clicked_stage_form_id, 
    type_val: ""
  });
  const [each_view_list,set_each_view_list] = useState([])

  const Alert = React.forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
  });

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const batch_task_id = params.get('id');
    const batch_id = params.get('batch_id');
    const batch_name = params.get('name');
    const sect_indx = params.get('si');
    const comp_indx = params.get('ci');
    setSectionIndex(sect_indx)
    setcompIndex(comp_indx)
    setbatch_task_name(batch_name);
    setbatch_id(batch_id);
    setbatch_task_id(batch_task_id);
    const activeStageName = params.get('activeStage');
    if (activeStageName && stage && stage.length > 0) { // Add this condition to ensure stage is not undefined or empty
      // Find the index of the active stage
      const activeStageIndex = stage.findIndex(stage => stage.stage_name === activeStageName);
      if (activeStageIndex !== -1) {
        setActivestage(activeStageIndex);
      }
    }

    let payloadGBTD = {
      batch_task_id: batch_task_id,
      batch_id: batch_id,
      token: localStorage.getItem('vector_token'),
    };

    httpClient.post('/get_batch_data', payloadGBTD)
      .then(response => {
        const {current_stage} = response.data.data.batch_task_details;
        const { stage_list } = response.data.data;
        const newstage = stage_list.map(stage => ({
          gate_access: stage.gate_access, // Does team member have access for gate action
          next_stage_lock: stage.next_stage_lock, // Adjust status based on stage_lock
          stage_name: stage.stage_name,
          next_stage_name: stage.next_stage_name,
          next_stage_id: stage.next_stage_id,
          form_id: stage.form_id, // Include form_id
          stage_id: stage.stage_id, // Include stage_id
          user_access: stage.user_access, // Include user_access
          user_access: stage.user_access, // Include user_access
        }));
        setstage(newstage);
        setCurrentStage(current_stage);
      })
      .catch(error => {
        console.error('Error fetching batch data:', error);
      });
  }, [location.search, each_view]);

  const handleSearchChange = (event) => {
    setSearchKey(event.target.value);
    // Add your search logic here
  };

  const [notiState, setNotiState] = React.useState({
    notiMessage : 'Sample Message',
    noti_open: false,
    noti_vertical: 'top',
    noti_horizontal: 'right',
    notiSeverity: 'success',
    duration_in_sec : 3000,
  });
  const { noti_vertical, noti_horizontal, noti_open,notiMessage, notiSeverity,duration_in_sec } = notiState;

  function ShowNotification(newState){
    setNotiState({ ...newState, noti_open: true });
  };

  function CloseNotification(){
    setNotiState({ ...notiState, noti_open: false });
  };

  const triggerNotification = (MsgType,Msg,duration_in_sec = 3000) => {
    ShowNotification({ noti_vertical: 'top', noti_horizontal: 'right', notiMessage: Msg,notiSeverity : MsgType, duration_in_sec: duration_in_sec });
  }

  function toggleFullscreen() {
    setFullScreenMode(!fullScreenMode);
  }

  useEffect(() => {
  }, [each_view,each_view_list]); // Add each_view as a dependency

  const close_forms = () =>{
    const updatedEachView = [{
      active: true,
      type: "form",
      type_id: clicked_stage_form_id,
      type_val: clicked_stage_text
    }];
    set_each_view_list(updatedEachView);
    setRefreshCnt((prev_val) => {return prev_val + 1});
  }

  function submit_form (form_link_data,section_index,comp_type,comp_indx){
    let view_form_obj = {}
    if(form_link_data!=null){
       view_form_obj = {
        active:true,
        type:'form',
        type_id: form_link_data.form_id,
        type_val: form_link_data.form_name,
        form_link_conf: form_link_data,
        form_link_status: true
      }
      }
      else{
         view_form_obj = {
          active:true,
          type:'form',
          type_id: form_link_data.par_form_id,
          type_val: form_link_data.form_name,
          form_link_data: null
        }
        }
        if(form_link_data.skip_primary == true){
          view_form_obj['type_val'] = ''
        }
        set_each_view_list((view_list)=>{
          const new_view_list = [ ...view_list]
          new_view_list.push(view_form_obj)
          return new_view_list;
        })
    
  }

  function disableWidgetorView(section_index,comp_type,comp_indx){
    setPageData((page_data) => {
      // Create a shallow copy of the previous state
      const newPageData = { ...page_data };
      // false the 'active' property for the specified widget
      newPageData.sections[section_index][comp_type][comp_indx].disabled = true;
      // Return the updated state
      return newPageData
    });
  }

  function get_curr_stage_and_move(){
    let payload= {
      batch_task_id: batch_task_id,
      batch_id: batch_id,
      token: localStorage.getItem('vector_token'),
    };

    httpClient.post('/get_curr_batch_stage', payload)
      .then(response => {
        const resp = response.data;
        if(resp.status){
          move_to_next_stage(resp.data);
        }
      })
      .catch(error => {
        console.error('Error fetching batch stage:', error);
        triggerNotification('error', "Please refresh the page!");
      });
  }

  function move_to_next_stage(next_stage_name){
    setOpenMoveStage(false);
    // console.log("\n\nmove_to_next_stage :: ",stage,curr_stage_name);
    // const currentStageIndex = stage.findIndex(eStage => eStage.stage_id === curr_stage_name);
    // console.log("next_stage_name :: ",next_stage_name);
    // if(stage[currentStageIndex].next_stage_name != null && stage[currentStageIndex].next_stage_name != 'end stage custom'){
    let next_stage_indx = stage.findIndex(eStage => eStage.stage_name === next_stage_name);
    // console.log("\n\nnext_stage_indx :: ",next_stage_indx);
    handleNavbarstageClick(next_stage_indx,stage[currentStageIndex].user_access);
    // }else{
    //   triggerNotification('error', "Please close this batch!");
    // }
  }

  function cancel_stage_lock(){
    setOpenMoveStage(false);
  }

  function tryMoveStage(click_stage){
    setOpenMoveStage(true);
    setTempStageCloseOnTry(click_stage);
  }

  const confirmNxtStageOpen = () => {
    if (tempStageCloseOnTry.next_stage_lock){
      let payloadmanuallock = {
        batch_task_id: batch_task_id,
        batch_id: batch_id,
        stage_id : stage_id,
        token: localStorage.getItem('vector_token'),
        form_id: clicked_stage_form_id,
      };
      httpClient.post('/stage_lock_action', payloadmanuallock)
      .then(response => {
        get_curr_stage_and_move();
      }).catch(error => {
        console.error('Error fetching batch data:', error);
      });
  };
}
  

  useEffect(() => {
    setShowDropdown(stage.length > 10);
  }, [stage]);

  useEffect(() => {
    setShowDropdown(false);
  }, [stage]);

  const handleDropdownClick = () => {
    setShowDropdown(!showDropdown);
  };

  useEffect(() => {
    // Find the index of the CurrentStage in the navbarstage array
    const currentStageIndex = navbarstage.findIndex(stage => stage.stage_name === CurrentStage);
    if (currentStageIndex !== -1) {
      // if (stage[currentStageIndex].user_access == 'edit'){
        handleNavbarstageClick(currentStageIndex,stage[currentStageIndex].user_access);
      // }else{
      //   triggerNotification('warning', 'Access Denied!');
      // }
    }
  }, [CurrentStage]); 

  
  function handleNavbarstageClick(index,stage_access) {
    setActivestage(index);
    if(stage_access == 'edit'){
      const clickedStage = stage[index];
      setstage_id(clickedStage.stage_id);
      setstage_name(clickedStage.stage_name)
      setclicked_stage_form_id(clickedStage.form_id);
      setclicked_stage_text(clickedStage.text)
      set_each_view_list([])
      const updatedEachView = {
        active: true,
        type: "form",
        type_id: clickedStage.form_id,
        type_val: clickedStage.text
        
      };
      set_each_view_list((view_list)=>{
        const new_view_list = [ ...view_list]
        new_view_list.push(updatedEachView)
        return new_view_list
      })
      setEachView(updatedEachView);
    }else{
      triggerNotification('error',"You don't have access to fill this form!");
    }
  }

  useEffect(() => {
    updateRandomValue();
  }, [stage_id]);

  // Function to generate a random string of characters
  const generateRandomString = () => {
    const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let randomString = '';
    for (let i = 0; i < 5; i++) {
      randomString += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    return randomString;
  }

  // Function to update the state with a new random value
  const updateRandomValue = () => {
    const randomValue = generateRandomString();
    setkeyUnmount(randomValue);
  }

  const completebatch = () => {
    let payloadmanuallock = {
      batch_task_id: batch_task_id,
      batch_id: batch_id,
      stage_id : stage_id,
      token: localStorage.getItem('vector_token')
    };
    httpClient.post('/mark_batch_complete', payloadmanuallock)
    .then(response => {
      triggerNotification('success', 'Batch Completed Successfully!');
      setopenCloseBatch(false);
      navigate(-1); // Move to batch list
    })
    .catch(error => {
      setopenCloseBatch(false);
      console.error('Error fetching batch data:', error);
    });
  }

  const navbarstage = stage.slice(0, 10);
  const dropdownstage = stage.slice(10);
  const currentStageIndex = navbarstage.findIndex(stage => stage.stage_name === CurrentStage);

  useEffect(() => {
    if(triggerCloseForms){
      setTriggerCloseForms(false);
      setSectionIndex(null);
      setCompType(null);
      close_forms();
    }
  }, [triggerCloseForms]); // Add each_view as a dependency

  function tryCloseBatch(){
    setopenCloseBatch(true);
  }

  function confirmcloseBatch(){
    completebatch();
  }

  function cancel_close_batch(){
    setopenCloseBatch(false);
  }
  

  return (
    <div className="batch-workflow-container"> {/* Wrap the entire content */}
       <Snackbar
        anchorOrigin={{ vertical :noti_vertical, horizontal: noti_horizontal }}
        open={noti_open}
        autoHideDuration={duration_in_sec}
        onClose={() => CloseNotification()}
        message={notiMessage}
        key={noti_vertical + noti_horizontal}
        style={{zIndex:2500}}
      >
        <Alert onClose={() => CloseNotification()} severity={notiSeverity} sx={{ width: '100%' }}>
          {notiMessage}
        </Alert>
      </Snackbar>
      <div className='alingItem'>
        <Grid container spacing={{ xs: 2, md: 3 }} columns={{ xs: 4, sm: 8, md: 13 }}>
          <Grid item xs={10}>
            <div className='sectionName'>
              {batch_task_name}
              {/* <button className="chart-button" onClick={handleChartButtonClick}>
                <img id="flowchart" src={flowchart} alt="flowchart" />
              </button> */}
            </div>
          </Grid>
          <Grid item xs={4}>
          </Grid>
        </Grid>
      </div>
      <div className='navbar'>
        {navbarstage.map((stage, index) => (
          // Check if the stage object exists and if it has the user_access property
          (stage && stage.user_access !== 'hide') && (
            <div key={index + keyUnmount}
              className={`navbar-stage stage${index + 1} ${activestage === index ? 'active' : ''}`}
              onClick={() => {
                // Only handle the click if index is less than or equal to currentStageIndex
                if (index <= currentStageIndex || (!stage.next_stage_lock) ){
                  handleNavbarstageClick(index,stage.user_access);
                }else{
                  triggerNotification('error', "This stage is not opened yet!");
                }
              }}
            >
              {(stage.stage_name === CurrentStage && stage.gate_access) ? (
                  stage.next_stage_name == 'end stage custom' ? (
                    <div className='complete-button' onClick={()=>tryCloseBatch()} ></div>
                  ):(
                    stage.next_stage_lock ? 
                    (<div className='lock-tab-button' onClick={()=>tryMoveStage(stage)} ></div>):
                    (<span style={{width: '30px'}}></span>)
                  ) 
                ) : (<span style={{width: '30px'}}></span>)}
              {index < currentStageIndex ? (
                <img src={tick} alt="Button Image" className='tick-tab-button' />
              ) : null}
              {stage.stage_name}
            </div>
          )
        ))}
        {navbarstage.length === 0 && (
          <div className="no-stages-message">  
          <Stack spacing={1}>
          <Skeleton
            sx={{ backgroundColor: 'rgba(255, 255, 255, 0.5)' }}
            animation="wave" />
          <Skeleton
            sx={{ backgroundColor: 'rgba(255, 255, 255, 0.5)' }}
            animation="wave" />
        </Stack>
      </div>
      
        )}
        {dropdownstage.length > 0 && (
          <div className={`navbar-dropdown ${showDropdown ? 'active' : ''}`}>
            <button className="navbar-dropdown-button" onClick={handleDropdownClick}>
              <ArrowDropDownIcon />
            </button>
            {showDropdown && (
              <div className="navbar-dropdown-content">
                {dropdownstage.map((stage, index) => (
                  // Check if the stage object exists and if it has the user_access property
                  stage && stage.user_access !== 'hide' && (
                    <div key={index} className="navbar-dropdown-item">
                      <img src={LockTabButton} className="stage-icon" />
                      {stage.stage_name}
                    </div>
                  )
                ))}
              </div>
            )}
          </div>
        )}
        <Dialog
          open={openMoveStage}
          onClose={() => cancel_stage_lock()}
        >
          <DialogTitle id="alert-dialog-title">
            {"Are you confirm to lock this stage?"}
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              Once it's locked, no further entries can be added or submitted.
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button type='warning' onClick={() => cancel_stage_lock()} autoFocus>
              No
            </Button>
            <Button onClick={() => confirmNxtStageOpen()} autoFocus>
              Yes
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog
          open={openCloseBatch}
          onClose={() => cancel_close_batch()}
        >
          <DialogTitle id="alert-dialog-title">
            {"Are you confirm to complete this batch?"}
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              Please confirm before marking batch as Completed!
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button type='warning' onClick={() => cancel_close_batch()} autoFocus>
              No
            </Button>
            <Button onClick={() => confirmcloseBatch()} autoFocus>
              Yes
            </Button>
          </DialogActions>
        </Dialog>  
      </div>
      <div className={`${fullScreenMode ? 'fullscreen-div' : ''}`}>
        {(stage && activestage !== null && stage[activestage] && stage[activestage].user_access != 'no view') ? (
          <div key={refreshCnt} className={`chat-template-container ${stage && activestage !== null && stage[activestage] && stage[activestage].user_access === 'view' ? 'disable-cursor' : ''}`}>
            {stage && activestage !== null && stage[activestage] && stage[activestage].user_access === 'view' && (
              each_view_list.map((each_view,view_indx)=>(
                <>
                  <ChatTemplate
                  key ={view_indx + stage[activestage].stage_id }
                    trigger_form_data={each_view}
                    trigger_section_index={sectionIndex}  // Adjust index as needed
                    trigger_comp_type={'views'}
                    trigger_comp_index={compIndex}   // Adjust index as needed
                    toggleFullscreen={toggleFullscreen}
                    triggerCloseForms_check={setTriggerCloseForms}
                    setSectionIndex={setSectionIndex}
                    setCompType={setCompType}
                    triggerNotification={triggerNotification}
                    batch_id = {batch_id}
                    stage_id ={stage_id}
                    stage ={stage_name}
                    batch_task_id ={batch_task_id}
                    submit_form = {submit_form}
                    disableWidgetorView={disableWidgetorView}
                    view_list = {each_view_list}
                  />
                </>
            )))
            }
      
            {stage && activestage !== null && stage[activestage] && stage[activestage].user_access === 'edit' && (
              each_view_list.map((each_view,view_indx)=>(
              <ChatTemplate
              key ={view_indx + stage[activestage].stage_id }
                trigger_form_data={each_view}
                trigger_section_index={sectionIndex}  // Adjust index as needed
                trigger_comp_type={'views'}
                trigger_comp_index={compIndex}   // Adjust index as needed
                toggleFullscreen={toggleFullscreen}
                triggerCloseForms_check={setTriggerCloseForms}
                setSectionIndex={setSectionIndex}
                setCompType={setCompType}
                triggerNotification={triggerNotification}
                batch_id = {batch_id}
                stage_id ={stage_id}
                stage ={stage_name}
                batch_task_id ={batch_task_id}
                submit_form = {submit_form}
                disableWidgetorView={disableWidgetorView}
                view_list = {each_view_list}
              />
            )))
            }
      
            {stage && activestage !== null && stage[activestage] && stage[activestage].user_access === 'view progress' && (
              <><h1 id='title-count'>Active progress</h1>
              Total : 22
              <h1 id='title-count'>Completed progress</h1>
              Total : 20
              </>
            )}
          </div>
        ):(
            (stage && (activestage !== null) && stage[activestage]) ? (
              <div className="disablebody" >
                  <div className='overlaytext'>You don't have access to add or submit entries in this form !</div>
              </div>
            ): null
        )}
      </div>
    </div>
  );
};  

export default BatchWorkflow;
